import axios from 'axios'
import {useCallback, useEffect, useRef, useState} from 'react'
import {useHistory, useParams} from 'react-router-dom'
import EmptyPageWidget from '../../../../global/widgets/EmptyPageWidget'
import {Container} from '../../../../modules/components'
import InternalNavigation from '../../../../modules/internalNavigation/InternalNavigation'
import {GetInvoiceDoctorByIdModel, GetInvoiceDoctorSuccessModel} from './models'
import InfoDoctorInvoiceSubpage from './subpages/InfoDoctorInvoiceSubpage'
import DoctorConsultInvoiceSubpage from './subpages/DoctorConsultInvoiceSubpage'
import generatePDF, {Margin, Options, Resolution} from 'react-to-pdf'

export default function ShowDoctorInvoice() {
    const {id}: {id: string} = useParams()
    const {doctorId}: {doctorId: string} = useParams()
    const [loading, setLoading] = useState(true)
    const [invoice, setStatement] = useState<GetInvoiceDoctorSuccessModel>()
    const history = useHistory()
    const downloadRef = useRef<HTMLDivElement | null>(null)

    const getTargetElement = () => document.getElementById('download-reference')
    const options = {
        method: 'save',
        resolution: Resolution.NORMAL,
        page: {
            margin: Margin.NONE,
            format: 'A4',
            orientation: 'landscape',
        },
        canvas: {
            mimeType: 'image/jpeg',
            qualityRatio: 1,
        },
    }

    const handleDownloadPDF = (invoice: GetInvoiceDoctorSuccessModel) => {
        const element = downloadRef.current

        if (element) {
            // 1. Exibe o conteúdo removendo 'd-none'
            element.classList.remove('d-none')

            generatePDF(getTargetElement, {
                ...options,
                ...{
                    filename: `faturamento-profissional-${invoice.doctor_invoice.reference_at.replaceAll(
                        '/',
                        '-'
                    )}`,
                },
            } as Options)

            element.classList.add('d-none')
        }
    }

    const getInvoice = useCallback(
        async (isUpdate = false) => {
            if (!invoice || isUpdate) {
                try {
                    const {data} = await axios.get<GetInvoiceDoctorByIdModel>(
                        `/core/billing/invoices/doctors/${id}/show/${doctorId}`
                    )
                    setStatement(data.data)
                } catch {
                    history.goBack()
                } finally {
                    setLoading(false)
                }
            }
        },
        [id, history, invoice, doctorId]
    )

    useEffect(() => {
        getInvoice()
    }, [getInvoice])

    return (
        <div className='row'>
            <Container loading={loading}>
                {invoice !== undefined ? (
                    <>
                        <div className='col-lg-12 text-end'>
                            <button
                                onClick={() => handleDownloadPDF(invoice)}
                                className={`btn btn-sm btn-light-primary mb-2`}
                            >
                                <i className={'fas fa-file-download'}></i>
                                Baixar relatório
                            </button>
                        </div>
                        <InternalNavigation
                            labels={['Informações', 'Serviços', 'Repasses']}
                            pages={{
                                info: <InfoDoctorInvoiceSubpage invoice={invoice.doctor_invoice} />,
                                consults: (
                                    <DoctorConsultInvoiceSubpage
                                        invoiceConsults={invoice.doctor_invoice_consults}
                                    />
                                ),
                            }}
                            titleSubmit='Cadastrar'
                            buttonNext={false}
                        />
                    </>
                ) : (
                    <EmptyPageWidget code={404} title='Não encontrado' />
                )}
                {invoice !== undefined && (
                    <div className='d-none' ref={downloadRef} id='download-reference'>
                        <div className='mb-5'>
                            <InfoDoctorInvoiceSubpage
                                invoice={invoice.doctor_invoice}
                                isExport={true}
                            />
                        </div>
                        <div className='mb-5'>
                            <DoctorConsultInvoiceSubpage
                                invoiceConsults={invoice.doctor_invoice_consults}
                                isExport={true}
                            />
                        </div>
                    </div>
                )}
            </Container>
        </div>
    )
}
